import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-planilla-pdf',
  templateUrl: './planilla-pdf.component.html',
  styleUrls: ['./planilla-pdf.component.scss'],
})
export class PlanillaPdfComponent implements OnInit {
  planillaUrl: string | null = null;
  safePlanillaUrl: SafeResourceUrl | null = null;
  errorMessage = '';

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.loadPlanillaFromSession();
  }

  private loadPlanillaFromSession(): void {
    const sessionRaw = sessionStorage.getItem('session');

    if (!sessionRaw) {
      this.errorMessage = 'No se encontró información de sesión.';
      return;
    }

    try {
      const session = JSON.parse(sessionRaw);

      const planilla = session?.dsSesion?.ttsesion?.[0]?.planilla;

      if (!planilla) {
        this.errorMessage = 'No se encontró la planilla en la sesión.';
        return;
      }

      this.planillaUrl = this.buildPdfUrl(planilla);
      this.safePlanillaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.planillaUrl
      );
    } catch (error) {
      console.error('Error leyendo session storage:', error);
      this.errorMessage = 'No se pudo leer la información de sesión.';
    }
  }

  private buildPdfUrl(planilla: string): string {
    const baseUrl = 'http://isla.rogiroaceros.com:9980';

    // Si ya viene completa no tocamos nada
    if (planilla.startsWith('http')) {
      return planilla;
    }

    return `${baseUrl}${planilla}`;
  }

  descargarPlanilla(): void {
    if (!this.planillaUrl) return;

    const link = document.createElement('a');
    link.href = this.planillaUrl;
    link.download = 'planilla.pdf';
    link.target = '_blank';
    link.click();
  }
}